export default __webpack_public_path__ + "static/media/Scorched Band of the Inferno.a977ba20.jpg";